export const RestEnds = {
  // Authentication
  CREATE_USER: "/v1/create-user",
  LOGIN: "/v1/login",
  REQUEST_OTP: "/v1/request-otp",
  VERIFY_EMAIL: "/v1/verify-email",
  VERIFY_ABN: "/v1/verify-abn",
  SECURITY: "/v1/security",
  USER: "/v1/user",
  USER_LOAN_STATUS: "/v1/user/loans",
  CREATE_USER_LOAN: "/v1/user/create-loan",
  GENERATE_USER_TOKEN: "/v1/user/token",

  //Loans
  LOANS: "/v1/loans",
  BANK_DETAILS: "/v1/bank-details",
  SOLICITOR_DETAILS: "/v1/solicitor-details",
  DOCUMENTS: "/v1/documents",
  GENERATE_MAPPING_DOCUMENTS: `v1/maploandocuments`,
  MAILED_DOCUMENTS: `/v1/document-mailed`,
  // --------RND
  RND_LOANS: "/v1/rnd/loans",
  RND_LOAN_CALCULATOR:"/v1/rnd/loan-calculator",

  //payment
  LOAN_PAY: "/v1/loan/pay",
  COST_CALCULATION: "/v1/loan/payment-calculation",
  PAYMENT_STATUS: "/v1/payment-status",

  CALCULATE_ELIGIBLE_LOAN: "/v1/calculateeligibleloan",

  //STAKEHOLDERS
  STAKEHOLDERS: "/v1/stakeholders",

  // KYC
  INITIATE_KYC: "/v1/initiate-kyc",
  INITIATE_KYC_MULTIPLE: "/v1/initiate-kyc/directors",
  RESEND_KYC: "/v1/resend-kyc",
  KYC_STATUS: (loanId: string, kycId: string) =>
    `/v1/kyc-status/${loanId}/${kycId}`,

  // Upload
  UPLOAD_DOCUMENT: "/v1/upload-document",
  ALL_MAPPED_DOCUMENTS: (offset: any, limit: any, loanId: string) =>
    `/v1/documents?offset=${offset}&limit=${limit}&loanId=${loanId}`,
  DOWNLOAD_SIGNED_DOCUMENT: "/v1/download-signed-document",
  SIGNERS_LIST: (offset: any, limit: any, loanId: string) =>
    `/v1/signers?offset=${offset}&limit=${limit}&loanId=${loanId}`,

  // Request
  REQUEST_CALL_BACK: "/v1/request-callback",

  //BROKERS
  BROKER: "/v1/broker",
};
